<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-withdrawal__withdrawal}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.userId" placeholder="用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('withdrawal:withdrawal:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('withdrawal:withdrawal:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键ID" width="200" header-align="center" align="center" v-show="false"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" width="200" align="center"></el-table-column>
        <el-table-column prop="memberNichen" label="用户昵称" header-align="center" width="200" align="center"></el-table-column>
        <el-table-column prop="withdrawalCode" label="提现单号" width="200" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="withdrawalSpecies" label="提现金币" width="150" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="withdrawalMoney" label="提现金额" width="150" header-align="center" align="center"></el-table-column>
        <el-table-column prop="frontSpecies" label="前余额" width="150" header-align="center" align="center"></el-table-column>
        <el-table-column prop="behindSpecies" label="后余额" width="150" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="type" label="收款类型( 1:支付宝  2:微信)" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="type" label="支付类型" :show-overflow-tooltip="true" width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 1" >支付宝</el-tag>
            <el-tag v-if="scope.row.type === 2" size="success" type="success">微信</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="imgUrl" label="收款码" width="150" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="imgUrl" label="收款码" header-align="center" align="center">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.imgUrl"
                :preview-src-list="evaluatePictureList"
                title="点击查看图片"
                @click="clickevaluatePicture(scope.row.imgUrl)"
              />
          </template>
         
        </el-table-column>
        <!-- <el-table-column prop="status" label="审核状态(0:待审核  1:审核通过  2:审核拒绝)" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="status" label="审核状态"  width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" size="warning" type="warning">待审核</el-tag>
            <el-tag v-if="scope.row.status === 1" size="success" type="success">审核通过</el-tag>
            <el-tag v-if="scope.row.status === 2" size="info" type="info">审核拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="审核内容" :show-overflow-tooltip="true" width="200" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('withdrawal:withdrawal:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('withdrawal:withdrawal:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './withdrawal-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/withdrawal/withdrawal/page',
        getDataListIsPage: true,
        exportURL: '/withdrawal/withdrawal/export',
        deleteURL: '/withdrawal/withdrawal',
        deleteIsBatch: true
      },
      evaluatePictureList:[],
      dataForm: {
        id: ''
      }
    }
  },
  methods: {
    clickevaluatePicture(url) {
      var srclist = []
      srclist.push(url) 
      this.evaluatePictureList = srclist// 赋值
    },
    selectTime(){
      if(this.times){
        console.log(this.times[0])
        console.log(this.times[1])
        this.dataForm.startTime = this.times[0]
        this.dataForm.endTime = this.times[1]
      }else{
        this.dataForm.startTime = ''
        this.dataForm.endTime = ''
      }
      console.log(this.dataForm)
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
